import React from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import styles from './index.less';

interface UnsupportedMetricBadgeProps {
  cause?: string;
}

export const UnsupportedMetricBadge = ({ cause }: UnsupportedMetricBadgeProps) => (
  <Tooltip placement="top" title={cause}>
    <WarningOutlined className={styles.warnIcon} />
  </Tooltip>
);
